import { createFileRoute, notFound } from "@tanstack/react-router";
import { getInfluencer, INFLUENCERS } from "@/lib/growth/influencerRegistry";
import { CountryInfluencerPage, CountryInfluencerNotFound } from "@/components/country/shared/CountryInfluencerPage";

export const Route = createFileRoute("/india/influencer/$slug")({
  loader: ({ params }) => {
    const inf = getInfluencer(params.slug);
    if (!inf || inf.country !== "IN") throw notFound();
    return inf;
  },
  head: ({ params }) => {
    const inf = INFLUENCERS[params.slug?.toLowerCase() ?? ""];
    const name = inf?.displayName ?? params.slug;
    const url = `https://versesport.com/india/influencer/${params.slug}`;
    const title = `Join the community of ${name} — VerseSport India`;
    const desc = `${name} community on VerseSport India: predictions, ranking and Nation Wars.`;
    return {
      meta: [
        { title },
        { name: "description", content: desc },
        { property: "og:title", content: title },
        { property: "og:description", content: desc },
        { property: "og:url", content: url },
        { property: "og:type", content: "website" },
      ],
      links: [{ rel: "canonical", href: url }],
    };
  },
  component: () => {
    const inf = Route.useLoaderData();
    return <CountryInfluencerPage influencer={inf} backHref="/india" backLabel="Back to VerseSport India" />;
  },
  notFoundComponent: () => <CountryInfluencerNotFound backHref="/india" backLabel="Back to VerseSport India" />,
});